import moment from 'moment';
import { create } from 'zustand';
import {
  AnalyticsStore,
  IAnalyticsContext,
  IPreviewAnalytic,
} from '../types/analytics';
import { IEnrichedMetadata } from '../types/metadata';

const useAnalyticsStore = create<AnalyticsStore>((set) => ({
  previewAnalytics: [],
  setPreviewAnalytics: (analytics: IPreviewAnalytic[]) =>
    set({ previewAnalytics: analytics }),

  enrichedMetadata: [],
  setEnrichedMetadata: (enrichedMetadata: IEnrichedMetadata[]) =>
    set({ enrichedMetadata: enrichedMetadata }),

  analyticsContext: {
    previewDatasetId: '',
    coordinates: [],
    pointName: '',
    categoryDataset: [],
    previewDatasetTimeRange: null,
    onDatasetChange: () => undefined,
  },
  setAnalyticsContext: (context: Partial<IAnalyticsContext>) =>
    set((state) => ({
      analyticsContext: { ...state.analyticsContext, ...context },
    })),

  isForAllAnalytics: false,
  setIsForAllAnalytics: (value: boolean) => set({ isForAllAnalytics: value }),

  globalDateRange: [],
  setGlobalDateRange: (range: moment.Moment[]) =>
    set({ globalDateRange: range }),
}));

export default useAnalyticsStore;
